<template>
  <!-- 话务管理-业务报表 -->
  <basic-container>
    <div class="business-report" :style="'height:' + (bodyHeight - 155) + 'px; overflow: scroll;'">
      <!-- 搜索表单 -->
      <el-form ref="searchFormRef" label-width="80px">
        <el-row>
          <el-col span="12">
            <el-form-item label="日期：">
              <el-date-picker
                v-model="dateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="text-align: right">
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" size="small" @click="searchChange">
                搜索
              </el-button>
              <el-button icon="el-icon-delete" size="small" @click="searchReset"> 清空 </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 统计汇总 -->
      <div class="box">
        <div class="item">
          <span>外呼数量</span>
          <span>{{ '15' }}</span>
        </div>
        <div class="item">
          <span>接听数量</span>
          <span>{{ '35' }}</span>
        </div>
        <div class="item">
          <span>通话时长(分)</span>
          <span>{{ '486' }}</span>
        </div>
        <div class="item">
          <span>报单数量</span>
          <span>{{ '62' }}</span>
        </div>
      </div>
      <!-- 图表 -->
      <div class="charts">
        <div id="chartObj1" class="chart"></div>
        <div id="chartObj2" class="chart"></div>
        <div id="chartObj3" class="chart"></div>
        <div id="chartObj4" class="chart"></div>
      </div>
    </div>
  </basic-container>
</template>

<script>
import { getProjectListApi } from '@/api/call-system/index';
import { getBusinessDataApi } from '@/api/call-system/call-manage/business-report';

export default {
  data() {
    return {
      projectId: '', // 项目id
      searchForm: {}, // 搜索条件
      dateRange: [], // 搜索条件-起止日期
      chartObj1: null,
      chartOpt1: {
        title: {
          text: '话务类别',
          left: 10,
          top: 10,
        },
        legend: {},
        tooltip: {},
        xAxis: {
          type: 'value',
        },
        yAxis: {
          type: 'category',
          data: [
            '2023-12-06',
            '2023-12-07',
            '2023-12-08',
            '2023-12-09',
            '2023-12-10',
            '2023-12-11',
          ],
        },
        series: [
          {
            name: '接听',
            type: 'bar',
            data: [7, 8, 10, 15, 11, 8],
          },
          {
            name: '外呼',
            type: 'bar',
            data: [4, 3, 2, 3, 4, 4],
          },
        ],
      },
      chartObj2: null,
      chartOpt2: {
        title: {
          text: '报单数量',
          left: 10,
          top: 10,
        },
        tooltip: {},
        xAxis: {
          type: 'category',
          data: [
            '2023-12-06',
            '2023-12-07',
            '2023-12-08',
            '2023-12-09',
            '2023-12-10',
            '2023-12-11',
          ],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: [2, 8, 4, 4, 6, 8, 6],
            type: 'bar',
          },
        ],
      },
      chartObj3: null,
      chartOpt3: {
        title: {
          text: '客户满意度',
          left: 10,
          top: 10,
        },
        legend: {},
        tooltip: {},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            '2023-12-06',
            '2023-12-07',
            '2023-12-08',
            '2023-12-09',
            '2023-12-10',
            '2023-12-11',
          ],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            name: '接听',
            type: 'line',
            data: [4, 2, 4, 2, 1, 5],
          },
          {
            name: '外呼',
            type: 'line',
            data: [5, 4, 4, 3, 5, 4],
          },
        ],
      },
      chartObj4: null,
      chartOpt4: {
        title: {
          text: '客户回访',
          left: 10,
          top: 10,
        },
        legend: {},
        tooltip: {},
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: [
            '2023-12-06',
            '2023-12-07',
            '2023-12-08',
            '2023-12-09',
            '2023-12-10',
            '2023-12-11',
          ],
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            type: 'line',
            stack: 'Total',
            data: [7, 15, 18, 27, 18, 10],
          },
        ],
      },
    };
  },
  created() {
    getProjectListApi().then(({ data }) => {
      if (data.length > 0) {
        this.projectId = data[0].id;
        this.loadData();
      }
    });
  },
  mounted() {
    this.initCharts();
  },
  methods: {
    /* 初始化图表 */
    initCharts() {
      this.chartObj1 = echarts.init(document.getElementById('chartObj1'));
      this.chartObj2 = echarts.init(document.getElementById('chartObj2'));
      this.chartObj3 = echarts.init(document.getElementById('chartObj3'));
      this.chartObj4 = echarts.init(document.getElementById('chartObj4'));
      this.chartObj1.setOption(this.chartOpt1);
      this.chartObj2.setOption(this.chartOpt2);
      this.chartObj3.setOption(this.chartOpt3);
      this.chartObj4.setOption(this.chartOpt4);
    },
    /* 加载数据 */
    loadData() {
      if (!this.projectId) return;
      getBusinessDataApi(Object.assign({ projectId: this.projectId }, this.searchForm)).then(
        ({ data }) => {
          // todo 重组数据赋值给chartOpt
          if (this.chartObj1) {
            this.chartObj1.setOption(this.chartOpt1);
          }
          if (this.chartObj2) {
            this.chartObj2.setOption(this.chartOpt2);
          }
          if (this.chartObj3) {
            this.chartObj3.setOption(this.chartOpt3);
          }
          if (this.chartObj4) {
            this.chartObj4.setOption(this.chartOpt4);
          }
        }
      );
    },
    /* 重置搜索 */
    searchReset() {
      this.dateRange = [];
      this.searchForm = {};
      this.loadData();
    },
    /* 条件搜索 */
    searchChange() {
      this.dealDateRange();
      this.loadData();
    },
    /* 转化日期范围 */
    dealDateRange() {
      if (this.dateRange && this.dateRange.length > 0) {
        this.searchForm.timeStart = this.dayjs(this.dateRange[0]).format('YYYY-MM-DD');
        this.searchForm.timeEnd = this.dayjs(this.dateRange[1]).format('YYYY-MM-DD');
      } else {
        this.searchForm.timeStart = '';
        this.searchForm.timeEnd = '';
        this.dateRange = [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.business-report {
  display: flex;
  flex-direction: column;
}
.box {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  column-gap: 20px;
  border: 1px solid #d3d4d5;
  padding: 10px 20px;
  height: auto;

  .item {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background: #f5f7fa;
    padding: 5px 10px;
    height: 60px;
  }
}

.charts {
  position: relative;
  width: 100%;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  margin-top: 20px;

  .chart {
    width: 49%;
    height: calc((100% - 40px) / 2);
    border: 1px solid #d3d4d5;
    margin-bottom: 10px;
  }
}
</style>
